<template>
  <div class="container">
    <div class="row">
      <div class="col-lg-4">
        <h2 class="h h--2 h--dark">Umowy</h2>
        <p class="paragraph">Lista wszystkich podpisanych przez Ciebie umów</p>
        <p class="paragraph--green">
          Łączna zarejestrowana kwota:
          <strong>{{
            parseFloat(user.total_sale).toFixed(2).replace(".", ",")
          }}
            PLN</strong><br />
        </p>
        <p class="paragraph">
          <router-link :to="{ name: 'InvoicesAdd' }" class="">
            Dodaj dowód zakupu &raquo;
          </router-link>
        </p>
      </div>
      <div class="col-lg-8" v-bind:class="{ pending: pagination.pending }">
        <div class="profile" v-if="contracts.length == 0">
          <p>brak umów</p>
        </div>
        <div v-else>
          <table class="invoices__table">
            <tr>
              <th colspan="6" class="with-table-td">
                <table>
                  <tr>
                    <th width="60">ID</th>
                    <th width="110">rozpoczęcie</th>
                    <th width="110">termin spłaty</th>
                    <th width="110">tytuł</th>
                    <th width="94">kwota</th>
                    <th width="94">spłacono</th>
                    <th class="text-right">status</th>
                  </tr>
                </table>
              </th>
              <th width="40"></th>
            </tr>
            <tr v-for="(contract, index) in contracts" :key="index">
              <td colspan="6" class="with-table-td">
                <table>
                  <tr>
                    <td width="60">{{ contract.id }}</td>
                    <td width="110">
                      {{ contract.created_at | formatDate("DD.MM.YYYY") }}
                    </td>
                    <td width="110">
                      {{ contract.deadline_at | formatDate("DD.MM.YYYY") }}
                    </td>
                    <td width="110">{{ contract.title }}</td>
                    <td width="94">
                      {{ contract.sale_amount | moneyDecimal }}
                    </td>
                    <td width="94">{{ contract.paid | moneyDecimal }}</td>
                    <td>
                      <span class="invoices__status" :class="'invoices__status--' + contract.status">{{ contract.status
                        }}</span>
                    </td>
                  </tr>
                  <tr v-if="contract.visible">
                    <td class="desc-td" colspan="7">
                      <div v-if="contract.description && contract.description != 'null'
            ">
                        <h4 class="invoices__heading">Opis:</h4>
                        <p v-html="contract.description"></p>
                      </div>
                      <h4 class="invoices__heading">Historia wpłat:</h4>
                      <p v-if="!contract.payments">Brak wpłat</p>
                      <div v-else class="row">
                        <div class="col-lg-10">
                          <table>
                            <tr>
                              <th width="60">ID</th>
                              <th width="110">data dodania</th>
                              <th width="94">kwota</th>
                              <th class="pl-3 text-left">komentarz</th>
                            </tr>
                            <tr v-for="(payment, index) in contract.payments" :key="index">
                              <td>{{ payment.id }}</td>
                              <td>
                                {{
            payment.created_at | formatDate("DD.MM.YYYY")
          }}
                              </td>
                              <td>{{ payment.amount | moneyDecimal }}</td>
                              <td class="pl-3 text-left">
                                {{ payment.description }}
                              </td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
              <td class="va-top">
                <a href="" @click.prevent="toggleDesc(contract)">
                  <img src="../../../assets/img/arrows_down.png" alt="" v-if="!contract.visible" />
                  <img src="../../../assets/img/arrows_up.png" alt="" v-if="contract.visible" />
                </a>
              </td>
            </tr>
          </table>
          <pagination class="pagination-wraper" v-model="pagination.current_page" :page="pagination.current_page"
            :per-page="parseInt(pagination.per_page)" :records="pagination.total" @paginate="onChangePaginate"
            v-if="pagination && pagination.last_page > 1"></pagination>
        </div>
      </div>
    </div>
    <page-box-set-widget></page-box-set-widget>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "ContractsComponent",
  data() {
    return {
      contracts: [],
      pagination: {},
      image: "",
      selected_photo: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: "get",
      url: "/contracts",
    })
      .then((notificationsReponse) => {
        var contracts = notificationsReponse.data.data.contracts;
        for (var inv in contracts) {
          contracts[inv].visible = false;
        }
        next((vm) => {
          vm.contracts = contracts;
          vm.pagination = notificationsReponse.data.pagination;
        });
      })
      .catch((error) => next(false));
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted: function () {
    if (!this.user || this.user.id != 1) {
      this.$gtag.pageview({
        page_path: "/umowy",
      });
    }
  },
  methods: {
    toggleDesc: function (inv) {
      inv.visible = !inv.visible;
    },

    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this;

      vm.pagination.pending = true;

      Vue.axios({
        method: "get",
        url: "/contracts",
        params: {
          page: page,
        },
      })
        .then((response) => {
          var contracts = response.data.data.contracts;
          for (var inv in contracts) contracts[inv].visible = false;

          vm.contracts = contracts;
          vm.pagination = response.data.pagination;
          vm.pagination.pending = false;
        })
        .catch((error) => (vm.pagination.pending = false));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/app/home/contracts/ContractsComponent.vue